import { BigNumber } from 'ethers'
import { Currency, CurrencyValue } from '../model'
import { normalizeTo18Decimals } from './normalize'

export function getCurrencyValues(currency: Currency, value: string): [CurrencyValue, BigNumber] {
  const currencyValue = CurrencyValue.fromString(currency, value)
  const currencyValue18 = normalizeTo18Decimals(currencyValue.value, currencyValue.currency.decimals)
  return [currencyValue, currencyValue18]
}
